import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Dashboard     from './Dashboard';
import AdminDogs     from './AdminDogs';
import AdminEvents   from './AdminEvents';
import AdminInquiries from './AdminInquiries';
import { AdminMemorial, AdminUsers, AdminSEO, AdminSettings } from './AdminMisc';
import './AdminLayout.css';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/admin'); };

  const navItems = [
    { to: '/admin/dashboard',  icon: '📊', label: 'Dashboard'  },
    { to: '/admin/dogs',       icon: '🐕', label: 'Dogs'       },
    { to: '/admin/events',     icon: '📅', label: 'Events'     },
    { to: '/admin/inquiries',  icon: '📋', label: 'Inquiries'  },
    { to: '/admin/memorial',   icon: '🌹', label: 'Memorial'   },
    { to: '/admin/users',      icon: '👥', label: 'Users'      },
    { to: '/admin/seo',        icon: '🔍', label: 'SEO'        },
    { to: '/admin/settings',   icon: '⚙️', label: 'Settings'   },
  ];

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar__brand">
          <span>🐾</span>
          <div>
            <div className="admin-sidebar__brand-name">Dog Town Rescue</div>
            <div className="admin-sidebar__brand-sub">Admin Panel</div>
          </div>
        </div>

        <nav className="admin-nav">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `admin-nav__item ${isActive ? 'admin-nav__item--active' : ''}`}
            >
              <span>{item.icon}</span> {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar__footer">
          <div className="admin-sidebar__user">
            <div className="admin-sidebar__user-name">{user?.name}</div>
            <div className="admin-sidebar__user-role">{user?.role?.replace('_', ' ')}</div>
          </div>
          <div style={{ display:'flex', gap:8, marginTop:12 }}>
            <a href="/" target="_blank" rel="noreferrer" className="admin-btn-sm">View Site</a>
            <button onClick={handleLogout} className="admin-btn-sm admin-btn-sm--danger">Logout</button>
          </div>
        </div>
      </aside>

      <main className="admin-main">
        <Routes>
          <Route index              element={<Dashboard />} />
          <Route path="dashboard"   element={<Dashboard />} />
          <Route path="dogs/*"      element={<AdminDogs />} />
          <Route path="events/*"    element={<AdminEvents />} />
          <Route path="inquiries"   element={<AdminInquiries />} />
          <Route path="memorial"    element={<AdminMemorial />} />
          <Route path="users"       element={<AdminUsers />} />
          <Route path="seo"         element={<AdminSEO />} />
          <Route path="settings"    element={<AdminSettings />} />
        </Routes>
      </main>
    </div>
  );
}
